const animationTimeout = 15;
export {
  animationTimeout
};
